import { render, staticRenderFns } from "./StateCard.vue?vue&type=template&id=c981f81e&"
import script from "./StateCard.vue?vue&type=script&lang=js&"
export * from "./StateCard.vue?vue&type=script&lang=js&"
import style0 from "./StateCard.vue?vue&type=style&index=0&id=c981f81e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports